import React, { useState, lazy } from 'react';
import PropTypes from 'prop-types';
import RenderComponent from './RenderComponent';
import { BACKEND_DATE_FORMAT } from 'globalconfig/constants/static';
import moment from 'moment';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Form = lazy(() => import(`globalcomponents/UI/Form/${layout}`));

const Filters = ({ hasApiStatus, callback, history, fleetCompanyList, filterList, handleReset, values, setInitialValues }) => {
  const [validationError, setValidationError] = useState('');
  const [endDateValidationError, setEndDateValidationError] = useState('');

  const handleSubmit = (fields) => {
    setValidationError('');
    setEndDateValidationError('');
    const finalData = {
      ...fields,
      startDate: moment(fields.startDate).format(BACKEND_DATE_FORMAT),
      endDate: moment(fields.endDate).format(BACKEND_DATE_FORMAT),
    };
    if (!fields.startDate) {
      setValidationError('Please select filter');
    }
    if (!fields.endDate) {
      setEndDateValidationError('Please select filter');
    }
    if (fields.startDate && fields.endDate) {
      Object.keys(finalData).forEach((key) => !finalData[key] && delete finalData[key]);
      filterList(finalData);
    }
  };

  const handleCancel = () => {
    handleReset();
    setInitialValues({
      startDate: '',
      endDate: '',
    });
    setEndDateValidationError('');
    setValidationError('');
  };

  return (
    <>
      <Form
        type="server"
        direction="row"
        initialValues={{ ...values }}
        className="CSAForms"
        RenderComponent={RenderComponent}
        handleOnSubmit={handleSubmit}
        handleOnCancel={handleCancel}
        customProps={{
          history,
          callback,
          hasApiStatus,
          validationError,
          endDateValidationError,
          fleetCompanyList,
          setInitialValues,
        }}
      />
    </>
  );
};

Filters.propTypes = {
  apiStatus: PropTypes.object.isRequired,
  callback: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
};

export default Filters;
